import ReadinessPanel from '@/components/landing/ReadinessPanel';
import { useTenantStore } from '@/stores/useTenantStore';

/**
 * Which clients can have a page built, across the whole book of business.
 *
 * ⚠ THIS LIVED AS A TAB INSIDE THE LANDING PAGES BUILDER, AND THAT WAS THE
 * WRONG HOME IN TWO WAYS. The builder answers "make a page for this client"
 * and is scoped to the selected workspace; this answers "which clients can we
 * build for at all", which is a different question about a different set. And
 * because the grid lists every client, a per-workspace page was quietly
 * showing one workspace's user the names and brand gaps of every other
 * client — invisible today only because tenant isolation is not yet enforced,
 * and a hole the moment it is.
 *
 * The endpoint is scoped to match: elevated roles see the roster, everyone
 * else sees the clients they are a member of.
 */
export default function PageBuilderOverviewPage() {
  const currentTenant = useTenantStore((s) => s.currentTenant);

  return (
    <div className="p-6">
      <header className="mb-6 max-w-3xl">
        <h1 className="text-2xl font-semibold">Page builder overview</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          What each client is missing before a page can be built. A gap here
          does not stop a build except for the lead form: the page falls back,
          showing the business name where a logo would go, or dropping the
          ratings strip when there is no proof on file.
        </p>
      </header>
      <ReadinessPanel tenantId={currentTenant ?? undefined} />
    </div>
  );
}
